import { useRef, useState } from "react";

import Menu from "./menu";
import Content from "./content";
import ActionBox from "./actionBox";
import InputComment from "../InputComment";
import Helpers from "../../commons/helpers";
import CircleProgress from "../CircleProgress";
import AvatarUserComment from "./avatarUserComment";

import { ChevronDown, ChevronUp } from "../../assets/icon/svg";
import { IDataComment, IReaction } from "../../commons/interfaces";

import "../../styles/comment.css";
import "../../styles/commentListView.css";

const _ = require("lodash");

const CommentListView = ({
    isReadMore,
    dataComment,
    requestLevel,
    reactionIcons,
    isDisableDelete,
    isDisableUpdate,
    isDisableReport,
    hiddenActionComment,
    updateMessage,
    deleteMessage,
    onViewReplyComment,
    onReportComment,
    sendMessage,
    readMoreComment,
    onHideReplyComment,
    createGuest,
    unReaction,
    reaction,
}: {
    isReadMore?: boolean;
    requestLevel: number;
    dataComment: IDataComment[];
    reactionIcons?: IReaction[];
    isDisableDelete?: boolean;
    isDisableUpdate?: boolean;
    isDisableReport?: boolean;
    hiddenActionComment?: boolean;

    deleteMessage: (messageId: string) => void;
    sendMessage: (message: string, replyTo?: string) => void; //cmt or reply cmt
    updateMessage?: (messageId: string, message: string) => void;
    readMoreComment?: () => void; //currentPage: page hiện tại c
    onReportComment?: (data: any) => void;
    onHideReplyComment?: (gene: string) => void;
    onViewReplyComment: (replyTo: string, level: number, index: number, pageNumber?: number, isReadMore?: boolean) => void;
    unReaction: (id: string) => void;
    createGuest?: (guestData: any) => void;
    reaction: (targetId: string, reactionCode: number) => void;
}) => {
    const commentRef = useRef<any>();

    //reply
    const idShowListRepliesByCommentIDRef = useRef<any>();

    const [isUpdate, setIsUpdate] = useState<boolean>(false);
    const [visibled, setVisibled] = useState<boolean>(false);
    const [idShowInputComment, setIdShowInputComment] = useState<string>("");
    const [dataReplyComment, setDataReplyComment] = useState<IDataComment>({} as IDataComment);

    const handleSetIdShowInputComment = (id: string) => {
        setIdShowInputComment(id);
    };

    const handleSetIsUpdate = (id: boolean) => {
        setIsUpdate(id);
    };

    const handleSetDataReplyComment = (data: IDataComment) => {
        setDataReplyComment(data);
    };

    const handleReadMoreReply = (item: any, index: number) => {
        setVisibled(true);
        setTimeout(async () => {
            let num = (item?.threadGene?.length || 0) / 5 - 1;
            onViewReplyComment(`${item.id}`, num, index, item.currentPage + 1, true);
            setVisibled(false);
        }, 100);
    };

    const handleReadMoreComment = () => {
        setVisibled(true);
        setTimeout(async () => {
            readMoreComment && readMoreComment();
            setVisibled(false);
        }, 100);
    };

    const handleShowComment = async (item: any, index: number) => {
        setVisibled(true);

        let dataTemp = [...idShowListRepliesByCommentIDRef.current || []];

        if (dataTemp.findIndex((id) => id === `${item.id}`) === -1) {
            dataTemp.push(`${item.id}`);
        } else {
            dataTemp = dataTemp.filter((id) => id !== `${item.id}`);
        }

        // setIdShowListRepliesByCommentID(dataTemp);
        idShowListRepliesByCommentIDRef.current = dataTemp;

        setTimeout(async () => {
            if (dataTemp.includes(`${item.id}`) && Helpers.isFunction(onViewReplyComment)) {
                let num = (item?.threadGene?.length || 0) / 5 - 1;
                await onViewReplyComment(`${item.id}`, num, index);
            } else if (Helpers.isFunction(onHideReplyComment)) {
                await onHideReplyComment(`${item.threadGene}`);
            }
            setVisibled(false);
        }, 100);
    };

    const debounceShowComment = _.debounce(async (item: any, index: number) => {
        handleShowComment(item, index);
    }, 500);

    return (
        <div>
            {dataComment?.map((item, index) => {
                let num = (item?.threadGene?.length || 0) / 5 - 1;
                let endNum = requestLevel - num;

                return (
                    // (item?.threadGene?.length === 10 || ([...idShowListRepliesByCommentIDRef.current || []].includes(`${item.id}`) || replyTo === item.id)) &&
                    <div
                        ref={commentRef}
                        key={`comment_${item.id}`}
                        className="cr-comment-box"
                        style={{
                            gridTemplateColumns: `${num === 1 ? 50 : 45}px auto`,
                            paddingLeft: num > 1
                                ? (endNum < 0 ? `${requestLevel * 32}px` : `${(num - 1) * 32}px`)
                                : "32px",
                        }}
                    >
                        {/* AvatarUserComment */}
                        <AvatarUserComment
                            level={num}
                            userId={item.userComment?.userId || ""}
                            avatarUrl={item.userComment?.avatarUrl}
                            userName={item.userComment?.fullName || item.userComment?.userName}
                        />

                        <div className="cr-box">
                            {/* content */}
                            <div className="cr-content-box">
                                <Content
                                    item={item}
                                    reactionIcon={reactionIcons || []}
                                    userId={item.userComment?.userId || ""}
                                    fullName={item.userComment?.fullName || ""}
                                    discussionValue={item?.discussionValue || ""}
                                />
                                <Menu
                                    item={item}
                                    isDisableDelete={isDisableDelete}
                                    isDisableUpdate={isDisableUpdate}
                                    isDisableReport={isDisableReport}
                                    deleteMessage={deleteMessage}
                                    onReportComment={onReportComment}
                                    handleSetDataReplyComment={handleSetDataReplyComment}
                                    handleSetIsUpdate={handleSetIsUpdate}
                                    handleSetIdShowInputComment={handleSetIdShowInputComment}
                                />
                            </div>

                            <div className="cr-box">
                                <ActionBox
                                    item={item}
                                    reaction={reaction}
                                    unReaction={unReaction}
                                    hiddenActionRetry={endNum < 0}
                                    reactionIcon={reactionIcons || []}
                                    hiddenAction={hiddenActionComment || false}
                                    handleSetDataReplyComment={handleSetDataReplyComment}
                                    handleSetIdShowInputComment={handleSetIdShowInputComment}
                                />
                                {/* Input Commet */}
                                {idShowInputComment && (
                                    <InputComment
                                        isComment={false}
                                        dataReplyComment={dataReplyComment}
                                        visible={idShowInputComment === `${item.id}`}
                                        onCancelComment={() => setIdShowInputComment("")}
                                        isReply={(replyTo: string) => setIdShowInputComment("")}
                                        isUpdate={isUpdate}
                                        updateDone={(status: boolean) => {
                                            setIdShowInputComment("");
                                            setIsUpdate(status);
                                        }}
                                        sendMessage={sendMessage}
                                        updateMessage={updateMessage}
                                        createGuest={createGuest}
                                    />
                                )}
                                <div>
                                    {Number(item.totalReply) > 0 && endNum >= 0 && (
                                        <div className="cr-row">
                                            <button
                                                className="cr-show-more cr-text-primary"
                                                onClick={() => debounceShowComment(item, index)}
                                            >
                                                {`${[...idShowListRepliesByCommentIDRef.current || []].includes(`${item.id}`) ? "Ẩn" : "Xem"} ${item.totalReply} câu trả lời`}

                                                {[...idShowListRepliesByCommentIDRef.current || []].includes(`${item.id}`)
                                                    ? (<ChevronDown />)
                                                    : (<ChevronUp />)
                                                }
                                            </button>
                                            {([...idShowListRepliesByCommentIDRef.current || []].findIndex(id => id === `${item.id}`) !== -1) && (
                                                <CircleProgress size={13} visibled={visibled} />
                                            )}
                                        </div>
                                    )}
                                    {[...idShowListRepliesByCommentIDRef.current || []].includes(`${item.id}`) &&
                                        Number(item?.totalPages) > Number(item?.currentPage) && (
                                            <div style={{ display: "flex" }}>
                                                <span
                                                    onClick={() => handleReadMoreReply(item, index)}
                                                    className="cr-read-more-comment-sub cr-text-primary"
                                                >
                                                    Xem thêm bình luận
                                                </span>
                                                <CircleProgress size={13} marginLeft={5} visibled={visibled} />
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
            {isReadMore && (
                <div style={{ display: "flex" }}>
                    <span
                        className="cr-read-more-comment cr-text-primary"
                        onClick={() => readMoreComment && handleReadMoreComment()}
                    >
                        Xem thêm bình luận
                    </span>
                    <CircleProgress size={13} marginLeft={5} visibled={visibled} />
                </div>
            )}
        </div>
    );
};

export default CommentListView;
